// extracted by mini-css-extract-plugin
module.exports = {"question":"Question_question__Qkbuy","content":"Question_content__Ohrlq","number":"Question_number__ymRM_","title":"Question_title__2jZ2T","answers":"Question_answers__vwJKh"};